import { CartItem } from 'src/sdk/cart/validate'
import { CarouselAnalyticsItem } from './typings'

export const getCarouselCardSku = (variants: string, url: string) => {
  const variantsProcessed = variants.split(',')

  const sku = checkSku(variantsProcessed, url)

  return sku
}

export const checkSku = (variants: string[], url: string) => {
  for (let element of variants) {
    if (url.includes(element)) {
      return element
    }
  }
  return null
}

export const getCarouselDataValue = (
  productLogic: string | undefined,
  content: string | undefined,
  email: string | null | undefined
) => {
  let dataValue = {}

  switch (productLogic) {
    case 'email':
      dataValue = email ? { 'data-email': `${email}` } : ''
      break
    case 'category':
      dataValue = { 'data-category': `${content}` }
      break
    case 'product':
      dataValue = { 'data-product': `${content}` }
      break
    case 'products':
      dataValue = { 'data-products': `[${content}]` }
      break
    case 'page':
      dataValue = { 'data-page': `${content}` }
      break
    case 'keywords':
      dataValue = { 'data-keywords': `${content}` }
      break
  }

  return dataValue
}

export const buildItemToAddToCart = (el: HTMLElement) => {
  const sku = getCarouselCardSku(
    el.dataset?.productSku ?? '',
    el.dataset.productUrl ?? ''
  )

  let result: CarouselAnalyticsItem = {
    carouselName: el.dataset.productCarouselName,
    category: el.dataset.productCategoryName,
    item: {
      id: el.dataset.productId ?? '',
      seller: { identifier: '1' },
      quantity: 1,
      // Need to convert this to a boolean since dataset returns string
      isKit: el.dataset.productIsKit === 'true',
      price: Number(el.dataset.productPrice),
      listPrice: Number(el.dataset.productListPrice),
      itemOffered: {
        sku: sku ?? '',
        name: el.dataset.productName ?? '',
        brand: { name: el.dataset.productBrand ?? '' },
        additionalProperty: [
          {
            propertyID: '',
            name: '',
            value: '',
            valueReference: '',
          },
        ],
      },
    } as CartItem,
  }

  return result
}
